var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDownloadCloud = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.00003 17L12 21L16 17",
  stroke: "#408996",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 12V21",
  stroke: "#408996",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.8799 18.09C21.7493 17.4786 22.4013 16.6061 22.7412 15.5991C23.0811 14.5921 23.0913 13.503 22.7703 12.4898C22.4493 11.4766 21.8138 10.5921 20.956 9.96453C20.0982 9.337 19.0628 8.99913 17.9999 8.99996H16.7399C16.4392 7.82784 15.8764 6.73921 15.0941 5.81604C14.3117 4.89288 13.3301 4.15922 12.2231 3.67032C11.1162 3.18141 9.91278 2.94999 8.70346 2.99348C7.49414 3.03697 6.31045 3.35423 5.24149 3.92139C4.17253 4.48855 3.24616 5.29081 2.53212 6.26779C1.81808 7.24477 1.33498 8.37101 1.11919 9.56171C0.903403 10.7524 0.960543 11.9766 1.28631 13.142C1.61208 14.3074 2.19799 15.3837 2.99993 16.29",
  stroke: "#408996",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownloadCloud, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/download-cloud.4bf9c693.svg";
export { ForwardRef as ReactComponent };